import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';


import { LoginComponent } from './login/login.component';
import { QrCodeModule } from 'ng-qrcode';
import { SetupTotpComponent } from './setup-totp/setup-totp.component';
import { RouterModule } from '@angular/router';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AuthenticationCodeComponent } from './authentication-code/authentication-code.component';
import { StoreModule } from '@ngrx/store';
import { loginReducer } from 'src/app/components/authentication/store/reducers/login.reducer';

import { AuthLayoutComponent } from './auth-layout.component';


import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ButtonModule } from 'primeng/button';


@NgModule({
    imports: [
    CommonModule,
    ReactiveFormsModule,
    StoreModule.forRoot({ login: loginReducer }),
    QrCodeModule,
    RouterModule,
    ButtonModule,
    AuthLayoutComponent,
    LoginComponent,
    SetupTotpComponent,
    ResetPasswordComponent,
    AuthenticationCodeComponent,
    ForgotPasswordComponent,
],
    exports: [
        AuthLayoutComponent,
        LoginComponent,
        SetupTotpComponent,
        ResetPasswordComponent,
        AuthenticationCodeComponent,
        ForgotPasswordComponent,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA, // Tells Angular we will have custom tags in our templates
    ],
})
export class AuthModule {}
